import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Sidebar } from './Dashboard';

const API = 'https://tribaltech-backend.onrender.com';

export default function Settings() {
  const [dropboxToken, setDropboxToken] = useState('');
  const [onlyfans, setOnlyfans]         = useState('');
  const [fansly, setFansly]             = useState('');
  const [saving, setSaving]             = useState(false);
  const [usernames, setUsernames]       = useState(['','','','','','','','','','']);
  const [saved, setSaved]               = useState(false);

  const token   = localStorage.getItem('tribal_token');
  const headers = { Authorization: 'Bearer ' + token };
  const user    = JSON.parse(localStorage.getItem('tribal_user') || '{}');

  // Load existing settings on mount. Without this, the form
  // always started empty even when values were in the DB, making
  // saves look like they hadn't persisted.
  useEffect(() => {
    axios.get(API + '/api/settings', { headers })
      .then(r => {
        const d = r.data || {};
        setOnlyfans(d.onlyfans_username || '');
        setFansly(d.fansly_username || '');
        setDropboxToken(d.dropbox_token || '');
        const existing = Array.isArray(d.usernames) ? d.usernames : [];
        // Fill 10 slots — existing values first, empties for the rest.
        setUsernames([...existing, ...Array(10).fill('')].slice(0, 10));
      })
      .catch(() => {});
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      await axios.post(API + '/api/settings', {
        dropbox_token: dropboxToken,
        usernames: usernames.filter(u => u.trim() !== ''),
        onlyfans_username: onlyfans,
        fansly_username: fansly,
      }, { headers });
      setSaved(true);
      setTimeout(() => setSaved(false), 3000);
    } catch (e) {
      alert('Save failed: ' + (e.response?.data?.error || e.message));
    }
    setSaving(false);
  };

  return (
    <div className="page">
      <Sidebar />
      <div className="main">
        <div className="page-title">Settings</div>

        <div className="card" style={{ marginBottom: 20 }}>
          <h3 style={{ fontSize: 15, marginBottom: 16 }}>Account</h3>
          <div style={{ fontSize: 14, color:'var(--muted)', marginBottom: 4 }}>Email</div>
          <div style={{ fontSize: 14, marginBottom: 16 }}>{user.email}</div>
          <div style={{ fontSize: 14, color:'var(--muted)', marginBottom: 4 }}>Plan</div>
          <div style={{ display:'flex', alignItems:'center', gap: 10 }}>
            <span className="badge badge-purple">{user.plan || 'Starter'}</span>
            <a href="/pricing" style={{ fontSize: 13 }}>Upgrade →</a>
          </div>
        </div>

        <div className="card" style={{ marginBottom: 20 }}>
          <h3 style={{ fontSize: 15, marginBottom: 4 }}>Platform usernames</h3>
          <div style={{ fontSize: 13, color:'var(--muted)', marginBottom: 16 }}>
            Used by the crawler to find your content on piracy sites
          </div>
          <div style={{ marginBottom: 14 }}>
            <label style={{ fontSize: 13, color:'var(--muted)', display:'block', marginBottom: 6 }}>OnlyFans username</label>
            <input value={onlyfans} onChange={e => setOnlyfans(e.target.value)} placeholder="tribalbbc" />
          </div>
          <div style={{ marginBottom: 14 }}>
            <label style={{ fontSize: 13, color:'var(--muted)', display:'block', marginBottom: 6 }}>Fansly username</label>
            <input value={fansly} onChange={e => setFansly(e.target.value)} placeholder="tribalbbc" />
          </div>
        </div>

        <div className="card" style={{ marginBottom: 20 }}>
          <h3 style={{ fontSize: 15, marginBottom: 4 }}>Connect Dropbox</h3>
          <div style={{ fontSize: 13, color:'var(--muted)', marginBottom: 16 }}>
            Creator Protect will scan and fingerprint your Dropbox content automatically
          </div>
          <div style={{ marginBottom: 14 }}>
            <label style={{ fontSize: 13, color:'var(--muted)', display:'block', marginBottom: 6 }}>Dropbox access token</label>
            <input
              type="password"
              value={dropboxToken}
              onChange={e => setDropboxToken(e.target.value)}
              placeholder="sl.xxxxxxxx..."
            />
          </div>
          <div style={{ fontSize: 12, color:'var(--muted)' }}>
            Get your token at dropbox.com/developers → App Console → your app → Settings → Generate access token
          </div>
        </div>

        <div className="card" style={{ marginBottom: 20 }}>
          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'baseline', marginBottom: 4 }}>
            <h3 style={{ fontSize: 15, margin: 0 }}>Usernames to monitor</h3>
            <span style={{ fontSize: 12, color:'var(--muted)' }}>
              {usernames.filter(u => u.trim() !== '').length}/10 used
            </span>
          </div>
          <div style={{ fontSize: 13, color:'var(--muted)', marginBottom: 16 }}>
            Add up to 10 usernames the crawler will search for across all piracy sites
          </div>
          {usernames.map((u, i) => (
            <div key={i} style={{ marginBottom: 10 }}>
              <input
                value={u}
                onChange={e => {
                  const updated = [...usernames];
                  updated[i] = e.target.value;
                  setUsernames(updated);
                }}
                placeholder={"Username " + (i+1)}
              />
            </div>
          ))}
        </div>

        <button
          className="btn btn-primary"
          onClick={save}
          disabled={saving}
          style={{ minWidth: 140 }}
        >
          {saving ? 'Saving...' : saved ? 'Saved!' : 'Save settings'}
        </button>
      </div>
    </div>
  );
}
